import MDButton from "components/MDButton";
import AddBoxIcon from "@mui/icons-material/AddBox";
import React, { useRef, useState, useEffect } from "react";
import MDModal from "components/MDModal";
import Grid from "@mui/material/Grid";
import Multiselect from "../Multi_Selecte/Multiselect";
import Singleselect from "../Single_Selecte";
import MDBox from "components/MDBox";
import InputBase from "@mui/material/InputBase";
import { alpha, styled } from "@mui/material/styles";
import TextareaAutosize from "@mui/material/TextareaAutosize";
import localforage from "localforage";
import MDTypography from "components/MDTypography";
import Payable from "./components/Payable";
import makeAnimated from "react-select/animated";
import "./modal.css";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import BundlePayable from "../OfferModal/components/Payable";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import Wrappar from "./Wrappar";
import env from "config";
const Service_modal = (props) => {
  const [openAddProduct, setOpenAddProduct] = useState(false);

  var stripeProducts = props.stripeProducts.filter(function (item) {
    return item.type != "recurring";
  });
  var striperecurringprod = props.stripeProducts.filter(function (item) {
    return item.type == "recurring";
  });
  var image_file = "";
  var loc_image_file = "";

  const BASE_URL = `${env.API_URL}/v1`;

  function AddProduct({ open, onClose }) {
    const BootstrapInput = styled(InputBase)(({ theme }) => ({
      "label + &": {
        marginTop: theme.spacing(3),
      },
      "& .MuiInputBase-input": {
        borderRadius: 4,
        position: "relative",
        backgroundColor: theme.palette.mode === "light" ? "#fcfcfb" : "#2b2b2b",
        border: "1px solid #ced4da",
        fontSize: 16,
        width: "100%",
        padding: "10px 12px",
        transition: theme.transitions.create([
          "border-color",
          "background-color",
          "box-shadow",
        ]),
        // Use the system font instead of the default Roboto font.
        fontFamily: [
          "-apple-system",
          "BlinkMacSystemFont",
          '"Segoe UI"',
          "Roboto",
          '"Helvetica Neue"',
          "Arial",
          "sans-serif",
          '"Apple Color Emoji"',
          '"Segoe UI Emoji"',
          '"Segoe UI Symbol"',
        ].join(","),
        "&:focus": {
          boxShadow: `${alpha(theme.palette.primary.main, 0.25)} 0 0 0 0.2rem`,
          borderColor: theme.palette.primary.main,
        },
      },
    }));
    const handleimage = async (e, type) => {
      if (type == "selling") {
        loc_image_file = e.target.files[0];
      } else {
        image_file = e.target.files[0];
      }
    };
    const handleSubmit = async (e) => {
      e.preventDefault();
      if (e.target.iframe_url.value.substr(0, 5) == "https") {
        var axios = require("axios");
        var loc_img_data = "";
        if (loc_image_file != "") {
          const loc_form_data = new FormData();
          loc_form_data.append("image", loc_image_file, loc_image_file.name);
          console.log(loc_form_data.get("image"));

          loc_img_data = await axios
            .post(`${BASE_URL}/utils/upload/image`, loc_form_data)
            .then((response) => {
              setOpenAddProduct(false);
              return response.data.data;
            });
        }
        const form_data = new FormData();
        form_data.append("image", image_file, image_file.name);
        console.log(form_data.get("image"));

        const img_data = await axios
          .post(`${BASE_URL}/utils/upload/image`, form_data)
          .then((response) => {
            // console.log(response.data,'image_data');
            setOpenAddProduct(false);

            return response.data.data;
          });
        const localBrand = await localforage.getItem("user");
        const agency_id = localBrand.agency_id;
        const name = e.target.name.value;
        const setup_payable = e.target?.setup_payable?.value;
        // const setup_payable = e.target.setup_payable.value;
        const management_payable = e.target.management_payable.value;
        // const setup_fee = e.target.setup_fee.value;
        const management_sub = e.target.management_sub.value;
        const category = e.target.category.value.split(",");
        const iframe_url = e.target.iframe_url.value;
        const service_type = e.target.service_type.value;
        const setup_fee = e.target.setup_fee.value;

        const workflows = e.target.workflows.value;
        const description = e.target.description.value;
        const cost_setup_payable = e.target.cost_setup_payable.value;
        const cost_setup_fee = e.target.cost_setup_fee.value;
        const cost_management_payable = e.target.cost_management_payable.value;
        const cost_management_sub = e.target.cost_management_sub.value;
        const lockfield = JSON.parse(e.target.lockfield.value);

        const selling_setup_payable = e.target.selling_setup_payable.value;
        const selling_setup_fee = e.target.selling_setup_fee.value;
        const selling_management_payable =
          e.target.selling_management_payable.value;
        const selling_management_sub = e.target.selling_management_sub.value;
        const image = img_data;

        const data = {
          resellable: e.target.resellable.value,
          name: name,

          lockfield: lockfield,
          description: description,

          service_type: service_type,

          setup_payable: setup_payable,
          setup_fee: setup_fee,
          management_payable: management_payable,
          management_sub: management_sub,
          // setup_fee: setup_fee,
          cost_setup_payable: cost_setup_payable,
          cost_management_payable: cost_management_payable,
          cost_setup_fee: cost_setup_fee,
          cost_management_sub: cost_management_sub,

          selling_setup_payable: selling_setup_payable,
          selling_management_payable: selling_management_payable,
          selling_setup_fee: selling_setup_fee,
          selling_management_sub: selling_management_sub,
          loc_name: e.target.loc_name.value,
          loc_description: e.target.loc_description.value,
          loc_iframe_url: e.target.loc_iframe_url.value,
          category: JSON.parse(category),
          iframe_url: iframe_url,
          workflows: workflows,
          image_url: image,
          agency_id: agency_id,
          loc_image_url: loc_img_data,
          type: "service",
        };
        console.log(data, "data");
        axios
          .post(`${BASE_URL}/seller/bundle`, { data })
          .then(async function (response) {
            console.log(response.data);
            props.handleChange(true);
            props.handlemessag("service  create successfully", "success");
          })
          .catch(function (error) {
            console.log(error);
            props.handlemessag("service not create successfully", "false");
          });
      } else {
        alert("please check your url make sure it will be start with https");
      }

      // // const { response } = await AppService.stripe.addSubscription({ payload })
    };
    return (
      <MDModal
        open={open}
        onClose={onClose}
        width={600}
        height={"auto"}
        overflow={"auto"}
        className="css-1stqary"
      >
        <MDBox>
          <MDTypography component="h1" mb={1} variant="h5">
            Service
          </MDTypography>

          <MDBox
            component="form"
            role="form"
            sx={{ width: 535 }}
            onSubmit={handleSubmit}
          >
            <Wrappar
              BootstrapInput={BootstrapInput}
              snapshots={props.snapshots}
              striperecurringprod={striperecurringprod}
              stripeProducts={stripeProducts}
              Purchasedapps={props.Purchasedapps}
              workflows={props.workflows}
              Catgories={props.Catgories}
              handleimage={handleimage}
            />
            {/* <Grid item md={12}>
              <MDBox mb={1}>
                <MDTypography variant="button" display="block" gutterBottom>
                  What is your service called?
                </MDTypography>
                <BootstrapInput
                  defaultValue=""
                  id="bootstrap-input"
                  fullWidth
                  placeholder="name"
                  name="name"
                />
              </MDBox>
            </Grid>
            <Grid item md={12}>
              <MDBox mb={1}>
                <MDTypography variant="button" display="block" gutterBottom>
                  Add your service description?
                </MDTypography>
                <TextareaAutosize
                  aria-label="minimum height"
                  minRows={1}
                  className="form-control"
                  name="description"
                  placeholder="description"
                  style={{ width: "100%", paddingLeft: "13px" }}
                />
              </MDBox>
            </Grid>
            <Grid container spacing={2}>
              <Grid item md={8}>
                <MDTypography variant="button" display="block" gutterBottom>
                  Upload a cover image for your service
                </MDTypography>
                <MDBox py={2}>
                  <input
                    type="file"
                    name="image"
                    className="form-control h-1"
                    onChange={handleimage}
                  />

                  <p className="img_text">
                    Upload a 640 x 360 pixel PNG, GIF, or JPG.
                  </p>
                </MDBox>
              </Grid>
              <Grid item md={4} mt={1} className="img_adj">
                <img
                  src="https://via.placeholder.com/100"
                  width={80}
                  height={80}
                  alt=""
                />
              </Grid>
            </Grid>
            <Grid item md={12}>
              <MDTypography
                mb={1}
                variant="button"
                display="block"
                gutterBottom
              >
                <span sx={{ display: "none" }}>
                  What categories does your service belong to?
                </span>
              </MDTypography>
              <MDBox mb={1} sx={{ fontSize: "14px" }}>
                <Multiselect data={props.Catgories} name="category" />
              </MDBox>
            </Grid>
            <Grid item md={12}>
              <MDTypography
                mb={1}
                variant="button"
                display="block"
                gutterBottom
              >
                What is the URL that tells customers about your service?
              </MDTypography>
              <MDBox mb={1}>
                <BootstrapInput
                  defaultValue=""
                  id="bootstrap-input"
                  fullWidth
                  placeholder="https://www.example.com/"
                  name="iframe_url"
                />
              </MDBox>
            </Grid>

            <Payable
              data={props.stripeProducts}
              edit_data={""}
              name={"purchase_listener"}
            />
            <Grid item md={12}>
              <MDTypography
                mb={1}
                variant="button"
                display="block"
                gutterBottom
              >
                When a customer purchases the service what workflow do you want
                to trigger?
              </MDTypography>
              <MDBox mb={1} sx={{ fontSize: "14px" }}>
                <FormControl sx={{ m: 0, minWidth: "100%" }}>
                  <InputLabel id="demo-simple-select-autowidth-label">
                    workflows
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-autowidth-label"
                    id="demo-simple-select-autowidth"
                    autoWidth
                    name="workflows"
                    label="workflows"
                  >
                    <MenuItem value="">
                      <em>None</em>
                    </MenuItem>
                    {props.workflows.map((workflows) => (
                      <MenuItem value={workflows.value} key="">
                        {workflows.label}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </MDBox>
            </Grid>
            <MDBox>
              <MDButton
                variant="gradient"
                color="info"
                type="submit"
                sx={{ mt: 1, mb: 1 }}
                fullWidth
              >
                Add
              </MDButton>
            </MDBox> */}
          </MDBox>
        </MDBox>
      </MDModal>
    );
  }

  const closeAddProduct = (subscription) => {
    //   if (subscription?._id) updateTable(subscription)
    setOpenAddProduct(false);
  };
  return (
    <>
      <MDButton
        sx={{ marginLeft: 3 }}
        variant="outlined"
        color="info"
        startIcon={<AddBoxIcon />}
        onClick={() => setOpenAddProduct(true)}
      >
        Service
      </MDButton>
      <AddProduct open={openAddProduct} onClose={closeAddProduct} />
    </>
  );
};

export default Service_modal;
